export const FETCH_SUBSCRIBER_CONSENTS_API =
	'agreements/subscribers/list?&subscriber_id=:id';
